import HttpClient from '@/utils/HttpClient';
import projectStore from '@/store/Projects';

export default {
  getReport() {
    return HttpClient.getAuthenticated(`/api/projects/${projectStore.activeProject.DbId}/report/main`);
  }
};
